export default __webpack_public_path__ + "c4d095fe83c7b7b5e1ea98ae96ceb01c.png";